import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Shield, Sparkles, Code2, Eye } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 py-16">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight mb-4">
          Un moteur qui ne vous regarde pas.
        </h1>
        <p className="text-xl text-gray-600 max-w-2xl leading-relaxed">
          OmniSearch est un moteur de recherche moderne, minimaliste, et orienté vie privée.
          Notre seul produit, c'est la recherche — pas vous.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6">
          {[
            { i: Shield, t: "Privé par design", d: "Pas de cookies de tracking, pas de profil utilisateur. Vos requêtes ne sont jamais vendues." },
            { i: Sparkles, t: "IA utile, pas envahissante", d: "Nous utilisons Claude Sonnet 4.5 uniquement pour résumer les résultats — pas pour générer du contenu fake." },
            { i: Code2, t: "Ouvert aux développeurs", d: "Une API publique propre permet d'embarquer la recherche partout, avec ou sans IA." },
            { i: Eye, t: "Honnête", d: "Les résultats proviennent de DuckDuckGo. Aucun classement publicitaire. Aucun favori caché." },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="p-6 rounded-lg border border-[var(--omni-border)]">
              <Icon className="text-[var(--omni-accent)] mb-3" size={22} />
              <h3 className="font-bold mb-1">{t}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 rounded-lg bg-[var(--omni-surface)] border border-[var(--omni-border)]">
          <h2 className="text-2xl font-bold mb-3">Astuces</h2>
          <ul className="text-sm text-gray-700 space-y-2">
            <li>· Appuyez sur <kbd className="px-1.5 py-0.5 rounded bg-white border border-[var(--omni-border)] font-mono text-xs">/</kbd> pour focus la barre de recherche.</li>
            <li>· Les utilisateurs connectés ont leur historique synchronisé.</li>
            <li>· Les développeurs peuvent générer une clé sur <Link to="/developers" className="text-[var(--omni-accent)] hover:underline">/developers</Link>.</li>
            <li>· Et il y a peut-être un easter egg caché quelque part… 👀</li>
          </ul>
        </div>
      </main>
      <Footer />
    </div>
  );
}
